"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataSourceValues = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var dataSource_1 = require("../functions/util/dataSource");
var useAPI_1 = require("./useAPI");
function useDataSourceValues(args) {
    var _a;
    var _b = react_1.useState(0), page = _b[0], setPage = _b[1];
    var _c = react_1.useState(true), isPageLoading = _c[0], setIsPageLoading = _c[1];
    var dataSourceArgs = {
        dataSourceKey: args.dataSourceKey,
        page: page,
        sort: args.sort,
        query: args.query,
    };
    var dataSourceValuesCall = useAPI_1.useAPI(args.getDataSourceValues, dataSourceArgs);
    react_1.useEffect(function () {
        setPage(0);
    }, [args.query]);
    var _d = react_1.useState([]), allItems = _d[0], setAllItems = _d[1];
    react_1.useEffect(function () {
        if (dataSourceValuesCall.data) {
            if (dataSourceValuesCall.data.first) {
                setIsPageLoading(false);
                setAllItems(dataSourceValuesCall.data.content);
            }
            else {
                setAllItems(function (items) {
                    return lodash_1.uniqBy(__spreadArrays(items, dataSourceValuesCall.data.content), "id");
                });
            }
        }
    }, [dataSourceValuesCall.data]);
    var loadMore = function () {
        if (!dataSourceValuesCall.isLoading &&
            !dataSourceValuesCall.data.last &&
            dataSourceValuesCall.data.content.length) {
            setPage(function (prevPage) { return prevPage + 1; });
        }
    };
    return {
        dataSourceUIListItems: dataSource_1.mapDSValueToUI(allItems, args.dataSourceKey),
        dataSourceValues: allItems,
        isLastPage: !!((_a = dataSourceValuesCall.data) === null || _a === void 0 ? void 0 : _a.last),
        isLoading: dataSourceValuesCall.isLoading,
        isPageLoading: isPageLoading,
        loadMore: loadMore,
    };
}
exports.useDataSourceValues = useDataSourceValues;
//# sourceMappingURL=useDataSourceValues.js.map